import React from 'react';
import { Link } from 'react-router-dom';
import { FiHeart } from 'react-icons/fi';
import { useWishlistStore } from '../store/wishlistStore';
import ProductCard from '../components/ProductCard';
import './Wishlist.css';

function Wishlist() {
  const { items } = useWishlistStore();

  return (
    <div className="wishlist-page">
      <div className="container">
        <div className="wishlist-header">
          <h1>
            <FiHeart size={28} className="wishlist-header-icon" />
            My Wishlist
          </h1>
          <p>{items.length} {items.length === 1 ? 'item' : 'items'} saved</p>
        </div>

        {items.length === 0 ? (
          <div className="wishlist-empty">
            <div className="wishlist-empty-icon">🤍</div>
            <h2>Nothing saved yet</h2>
            <p>Tap the heart on any product to save it here.</p>
            <Link to="/products" className="btn btn-primary wishlist-browse-btn">Browse Products</Link>
          </div>
        ) : (
          <div className="grid grid-cols-3 wishlist-grid">
            {items.map((p, i) => (
              <div key={p.id} className="product-grid-item" style={{ '--i': i }}>
                <ProductCard product={p} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Wishlist;
